module.exports = __webpack_public_path__ + "img/empty_image001_puple.4594d834.png";